import { UserRole } from '../types/user';
import { ProfileResponse } from '../types/profile';
import { apiService } from './api';
import axios from 'axios';

export interface ProfileUpdateData {
  profileName: string;
  mobile?: string | null;
  country: string;
  linkedinUrl: string;
  specialty: string;
  company: string;
  experience: string;
  languages: string[];
  purpose: string | null;
  profilePictureUrl?: string | undefined;
  availableTimeSlots?: Array<{
    startTime: Date;
    endTime: Date;
    isAvailable: boolean;
  }>;
}

export const profileService = {
  async getProfile(): Promise<ProfileResponse> {
    return apiService.profile.getProfile();
  },

  async updateProfile(data: ProfileUpdateData, file?: File): Promise<ProfileResponse> {
    const requestData = {
      ...data,
      mobile: data.mobile || null
    };
    return apiService.profile.updateProfile(requestData, file);
  },

  async updateUserRole(role: UserRole): Promise<{ token: string; roleId: number; userId: string }> {
    try {
      const response = await axios.put('/api/profile/role', { role });
      return response.data;
    } catch (error) {
      console.error('Error updating user role:', error);
      const message = axios.isAxiosError(error) 
        ? error.response?.data?.message || 'Failed to update user role'
        : 'Failed to update user role';
      throw new Error(message);
    }
  },

  async getTimeSlots() {
    return apiService.timeSlots.get();
  },

  async updateTimeSlots(timeSlots: Array<{
    startTime: Date;
    endTime: Date;
    isAvailable: boolean;
  }>) {
    return apiService.timeSlots.update(timeSlots);
  },
}; 